import React, { Component } from 'react';
import { Button, Modal, Image } from 'react-bootstrap';
import './Header.css';
import utils from './../../utils';
import PropTypes from 'prop-types';
import EndpointConstant from './../../constants/EndpointConstant';
import MessageConstant from '../../constants/MessageConstant';
import { msalInstance, initializeMsal } from "./../../msalInstance"

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      alertBody: '',
      alertTitle: '',
      showAlert: false,
      showLogoutConfirmation: false
    };
    this.role = '';
    this.showAlertDialog = this.showAlertDialog.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleLogoutClose = this.handleLogoutClose.bind(this);
    this.logout = this.logout.bind(this);
    this.logoutUser = this.logoutUser.bind(this);
  }
  handleLogoutClose() {
    this.setState({ showLogoutConfirmation: !this.state.showLogoutConfirmation })
  }
  // showLogoutConfirmation(){
  //   this.setState({showLogoutConfirmation:false})
  // }
  showAlertDialog(text, title) {

    // console.log("showAlertDialog ============= ");

    this.setState({
      alertBody: text,
      alertTitle: title ? title : 'Alert',
      showAlert: true
    });
  }
  async logoutUser() {
    await initializeMsal();
    const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];  

    const emailId = utils.getSessionItem("registerE");           
    // window.location.href =`${window.okta.issuer}${window.okta.tenantId}/oauth2/v2.0/logout`+`?logout_hint=${encodeURIComponent(emailId)}`+`&post_logout_redirect_uri=${window.location.origin}${window.okta.logoutUri}`
    
    msalInstance.logoutRedirect({
        account,
        postLogoutRedirectUri: `${window.location.origin}${window.okta.logoutUri}`,
        onRedirectNavigate: (url) => {   
          window.localStorage.clear();                          
          utils.setSessionItem("registerE", emailId);
          // 1. Clear the active account reference from MSAL memory   
          msalInstance.setActiveAccount(null);
          // 2. Returning false blocks MSAL from redirecting the user to the Microsoft Selection page.
          // It successfully wipes your local MSAL cache data before executing this block.
          // Directly route the user straight to your destination/Okta clearing endpoint
          window.location.assign(`${window.location.origin}${window.okta.logoutUri}`);
          return false; 
      }
    });
  }
  logout() {
    let self = this;
    let data = {};
    utils.makeRequest(this, EndpointConstant.LOGOUT, data, function (result) {
      //console.log(result, 'result');
      if (result.error === false) {
        utils.showLoader();
        window.sessionStorage.clear();
        self.logoutUser();

      }

    });
  }
  handleClose() {
    this.setState({ showAlert: false });
  }
  render() {
    const siteInfo = JSON.parse(utils.getSessionItem("SiteInfo"));
    const currentRole = utils.getSessionItem("role");
    if (siteInfo.hasOwnProperty("UserRoles")) {
      this.role = siteInfo.UserRoles[currentRole];
    }

    return (
      <div className="header">
        <div className="header-title"><Image src="/Images/Logo.png" fluid />
          <h4 className="logo"> <span>|</span> GLOBAL INTAKE MONITORING SYSTEM</h4>
        </div>
        
        <div className={this.props.hideWelcomeMsg ? 'hidden' : 'header-right'}>
          {/* <Image src=" " className='imageStyle' ></Image> */}
          <div className="trainingGuide">
        <a href={siteInfo.TrainingGuide.trainingGuideLink} target="_blank"><u>User Training Guide</u></a>
        </div>
          <i className="far fa-user-circle imageStyle"></i>

          <div className="header-label mr-4">
            {utils.hasSessionItem("firstName") ? <span className='firstName'>{utils.getSessionItem("firstName")} {utils.getSessionItem("lastName")}</span> : ''}<br />
            {utils.hasSessionItem("role") ? <span className='roleStyles'>{this.role}</span> : ''}

          </div>
          <i className="fas fa-power-off text-danger power" onClick={this.handleLogoutClose}></i>
        </div>
        <div>
          <Modal size="sm" show={this.state.showAlert} onHide={this.handleClose} aria-labelledby="example-modal-sizes-title-sm">
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-sm">
                {this.state.alertTitle}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>{this.state.alertBody}</Modal.Body>
            <Modal.Footer>
              <Button active variant="secondary" onClick={this.handleClose}>
                Ok
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            dialogClassName="deletionModal"
            show={this.state.showLogoutConfirmation}
            onHide={this.handleLogoutClose}
            aria-labelledby="example-custom-modal-styling-title">
            <Modal.Header className='confirmation-header'>
              <Modal.Title id="example-modal-sizes-title-sm">
                Confirmation
          </Modal.Title>
            </Modal.Header>
            <Modal.Body className='confirmation-body'> {MessageConstant.LOGOUT_CONFIRMATION}</Modal.Body>
            <Modal.Footer className='confirmation-footer'>
              <Button onClick={this.handleLogoutClose} className='clear'>
                No
          </Button>
              <Button active onClick={this.logout}>
                Yes
    </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}
Header.propTypes = {
  hideWelcomeMsg: PropTypes.string,
  auth: PropTypes.object

}
export default Header;
